interface StatusConfig {
  badge: string
  label: string
}

const statusConfigs = new Map<string, StatusConfig>([
  [
    'AWAITING_DEPOSIT',
    {
      badge: 'bg-amber-100 text-amber-700 border border-amber-200',
      label: "En attente d'acompte",
    },
  ],
  [
    'CANCELLED',
    {
      badge: 'bg-red-100 text-red-700 border border-red-200',
      label: 'Annulé',
    },
  ],
  [
    'DEPOSIT_PAID',
    {
      badge: 'bg-teal-100 text-teal-700 border border-teal-200',
      label: 'Acompte versé',
    },
  ],
  [
    'FULLY_PAID_PENDING',
    {
      badge: 'bg-emerald-100 text-emerald-700 border border-emerald-200',
      label: 'Soldé',
    },
  ],
  [
    'FULLY_PAID_TRAVELED',
    {
      badge: 'bg-green-100 text-green-800 border border-green-200',
      label: 'Voyage terminé',
    },
  ],
])

const fallbackConfig: StatusConfig = {
  badge: 'bg-gray-100 text-gray-600 border border-gray-200',
  label: 'Inconnu',
}

interface BookingStatusBadgeProps {
  status: string
}

export function BookingStatusBadge({ status }: BookingStatusBadgeProps) {
  const config = statusConfigs.get(status) ?? fallbackConfig

  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-1 text-xs font-semibold ${config.badge}`}
    >
      {config.label}
    </span>
  )
}
